const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';

export const loadRecaptchaScript = () => {
  return new Promise((resolve, reject) => {
    if (!RECAPTCHA_SITE_KEY) {
      resolve();
      return;
    }

    if (document.getElementById('recaptcha-script')) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.id = 'recaptcha-script';
    script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load reCAPTCHA script'));
    document.head.appendChild(script);
  });
};

export const executeRecaptcha = async (action = 'submit') => {
  if (!RECAPTCHA_SITE_KEY) {
    return null;
  }

  try {
    if (!window.grecaptcha || !window.grecaptcha.execute) {
      await loadRecaptchaScript();
      await new Promise((resolve, reject) => {
        let elapsed = 0;
        const checkReady = setInterval(() => {
          elapsed += 100;
          if (window.grecaptcha && window.grecaptcha.ready) {
            clearInterval(checkReady);
            resolve();
          } else if (elapsed > 5000) {
            clearInterval(checkReady);
            reject(new Error('reCAPTCHA load timeout'));
          }
        }, 100);
      });
    }

    return new Promise((resolve, reject) => {
      window.grecaptcha.ready(async () => {
        try {
          const token = await window.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action });
          resolve(token);
        } catch (error) {
          reject(error);
        }
      });
    });
  } catch {
    return null;
  }
};

export const isRecaptchaAvailable = () => {
  return !!(RECAPTCHA_SITE_KEY && window.grecaptcha && window.grecaptcha.execute);
};
